import { setCountryUserProperty } from "./analytics"
import { localStorageItems } from "./storage"
import { getLocationInfo } from "../networking/user"

export const getStoredCountry = (): string | null =>
  localStorage.getItem(localStorageItems.country)

const storeCountry = (country: string) => {
  localStorage.setItem(localStorageItems.country, country)
  // Set as an Amplitude user property whenever we resolve a new country
  // (from URL param or the IP lookup).
  setCountryUserProperty(country)
}

/**
 * Resolve & persist the user's country code once, mirroring the language flow:
 *   1. `?country=` URL param (explicit override — e.g. campaign links)
 *   2. existing localStorage value (returning visitors)
 *   3. ipapi.co IP lookup
 *
 * The raw code is stored as-is and sent on every request via joon-api. We do NOT
 * filter/normalize/default it here — the backend decides how to map and handle
 * each country (including any fallback). Fire-and-forget at app startup.
 */
export const initCountry = async (): Promise<string | null> => {
  const urlCountry = new URLSearchParams(window.location.search)
    .get("country")
    ?.trim()
  if (urlCountry) {
    storeCountry(urlCountry)
    return urlCountry
  }

  const stored = getStoredCountry()
  if (stored) return stored

  try {
    const { data } = await getLocationInfo()
    if (data.country_code) {
      storeCountry(data.country_code)
      return data.country_code
    }
  } catch {
    // Don't persist on failure so we retry on the next load.
  }
  return null
}
